import styles from './VideoBackground.module.css';

export default function VideoBackground() {
  return (
    <div className={styles.wrapper} aria-hidden>
      <video
        className={styles.videoMobile}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      >
        <source src={`${process.env.PUBLIC_URL}/fondo1.mp4`} type="video/mp4" />
      </video>
      <video
        className={styles.videoDesktop}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      >
        <source src={`${process.env.PUBLIC_URL}/fondo2.mp4`} type="video/mp4" />
      </video>
    </div>
  );
}
